import React, { Component } from "react";

class ReviewSearchItem extends Component {
	render() {
		const { isSelected, item, index } = this.props;

		return (
			<div
				className={"selection" + (isSelected ? " selected" : "")}
				onClick={() => this.props.handleClick(item, index)}
			>
				<div className="txt">{item.title}</div>
			</div>
		);
	}
}

export default ReviewSearchItem;



// WEBPACK FOOTER //
// ./src/components/reviews/review-search/ReviewSearchItem.js